import { createTheme } from '@mui/material/styles';

// Paleta extraída de los colores ya usados en toda la app (components/main.css:
// card-header-app, botones, bordes de foco) en vez de inventar una nueva.
const theme = createTheme({
  palette: {
    primary: {
      dark: '#083a94',
      main: '#1976d2',
      light: '#21a1ff',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
